import { useEffect } from "react";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import About from "./pages/About";
import HejMamma from "./pages/HejMamma";
import Wedding from "./pages/Wedding";
import Booking from "./pages/Booking";
import Work from "./pages/Work";
import WorkAll from "./pages/WorkAll";
import JobDetail from "./pages/JobDetail";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextMenu);
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  return (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Sonner />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/hej-mamma" element={<HejMamma />} />
        <Route path="/brollopsfotograf" element={<Wedding />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/work" element={<WorkAll />} />
        <Route path="/work/:category" element={<Work />} />
        <Route path="/work/:category/:job" element={<JobDetail />} />
        <Route path="/admin" element={<Admin />} />

        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </TooltipProvider>
  </QueryClientProvider>
  );
};

export default App;
